module.exports = __webpack_public_path__ + "static/media/flogo.016efa8e.png";